export default __webpack_public_path__ + "static/media/item2.aaf6b9ce.png";